module.exports = __webpack_public_path__ + "img/chinesecompany117.67cdaac2.png";